import React from 'react';
import { Link } from "react-router-dom";
import './MyApproachSection.css';

function MyApproachSection() {
  return (
    <div className="my-approach-section">
      <div className="my-approach-image">
        <img src="/images/healing-hand.jpeg" alt="Hand with leaves" loading="lazy" decoding="async" />
      </div>
      <div className="my-approach-content">
        <h2>Work With Me</h2>
        <p>
          I am a Brennan Healing Science ® Practitioner, an advanced modality of energy healing that combines hands-on healing techniques with spiritual and psychological processes. 
        </p>
        <p>
          Mostly, I am a dancer, lover of the body and lover of this world. With Brenann Healing Science as a foundational base, I create my own personal
          healing signature that is based on devotion to what truly is. My intention is to help bring clients closer to the source of Love and to help unveil the blockages that prevent the Soul from being heard, witnessed and experienced.
        </p>
        <p>I work on creating an intelligent container imbued with the energy of acceptance, where together we can work with all the material that is present–our gifts and the parts of ourselves that we exile. 
          This can help us not only discover, but also be active participants in the co-creation of the picture that our Soul longs to paint.</p>
        <Link to="/my-practice" className="my-approach__learn-more-btn">
          Learn More
        </Link>
      </div>
    </div>
  );
}

export default MyApproachSection;
